<template>
  <div class="mdc-textfield-container search-input" v-bind:class="textfieldClassBinding">
    <label for="search-input">
      <img src="/static/images/icon-search.svg" alt="">
    </label>
    <div class="mdc-textfield">
      <input type="search"
             id="search-input"
             class="mdc-textfield__input"
             v-bind:value="text"
             v-on:input="onInput"
             v-on:focus="focusInput"
             v-on:blur="blurInput"
             v-bind:placeholder="$t('common.browse_filters.search_placeholder')">
      <div class="cancel-input-btn" v-on:click="clearInput">
        <img src="/static/images/icon-cancel.svg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  import clickout from '../mixins/clickout';

  export default {
    name: 'search-input',

    props: {
      modelValue: {
        type: String,
        default: '',
      },
    },

    mixins: [
      clickout,
    ],

    data() {
      return {
        isFocused: false,
      };
    },

    computed: {
      text() {
        return this.modelValue || '';
      },

      textfieldClassBinding() {
        return {
          'textfield-focused': this.isFocused,
        };
      },
    },

    methods: {
      focusInput() {
        this.isFocused = true;
      },

      blurInput() {
        setTimeout(() => {
          this.isFocused = false;
        }, 200);
      },

      onInput(event) {
        this.$emit('input', event.target.value);
      },

      clearInput() {
        this.$emit('input', '');
        this.isFocused = false;
      },

      clickOutListener() {
        this.isFocused = false;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/SearchInput.vue